/* 

 */

import mopaBootstrapCollection from 'mopa/bootstrap-bundle/Resources/public/js/mopabootstrap-collection.js';
import fileUpload from 'blueimp-file-upload/js/jquery.fileupload.js';

!function ($) {
	"use strict";

	var FileCollection = function (element, options) {
		this.$element = $(element);
		this.$container = this.$element.closest('.form-group');
		this.options = $.extend({}, $.fn.collection.defaults, options);

		// This must work with "collections" inside "collections", and should
		// select its children, and not the "collection" inside children.
		var $collection = $(this.options.collection_id);

		// Indexes must be different for every Collection
		if (typeof this.options.index === 'undefined') {
			this.options.index = {};
		}
		if (!this.options.initial_size) {
			this.options.initial_size = $collection.children().length;
		}

		this.options.index[this.options.collection_id] = this.options.initial_size - 1;
	};

	var extensionMethods = {
		constructor: FileCollection,
		timeoutID: null,
		progress: function(data){
			var progress = parseInt(data.loaded / data.total * 100, 10);
			window.clearTimeout(this.timeoutID);
			this.$container.find('.upload-progress').show().text('Progress: ' + progress + '%');
			if(progress == 100){
				this.$container.find('.upload-progress').text('Files added.');
				var self = this;
				this.timeoutID = window.setTimeout(function(){
					self.$container.find('.upload-progress').fadeOut(400);
				}, 4000);
			}
		},
		error: function(errors){
			if(typeof errors === 'string' || errors instanceof String)
				errors = [ errors ];

			var error_str = errors.join('<br>');
			this.$container.find('.file-errors').append(error_str+'<br>').show();
			this.$container.find('.upload-progress').hide();
		},
		wipeError: function(){
			this.$container.find('.file-errors').html('').hide();
			this.$container.find('.upload-progress').hide();
		},
		fileAdd: function(data){
			this.add();

			this.warnOnNav();

			var $current_item = $(this.getItem(this.options.index[this.options.collection_id]));

			// Set file info
			$current_item.find('.icon').addClass('fa-'+data.file_icon_class);
			$current_item.find('.filename').text(data.name);
			$current_item.find('.file-id').val(data.id);
			$current_item.find('.download-link').attr("href", data.url);

			// Style the added file
			$current_item.find('.file-collection-file').addClass('added');
			$current_item.find('.filename').append($('<span class="added-label">Added</span>'));
		},
		remove: function(){
			var $file = this.$element.closest('.file-collection-file');

			this.warnOnNav();

			if(!$file.find('.file-delete')[0].checked){
				$file.addClass('removed');

				$file.find('.file-collection-delete').text('Undo Removal');
				$file.find('.download-button').hide();
				$file.find('.filename').append($('<span class="removed-label">Removed</span>'));
			}else{
				$file.removeClass('removed');

				$file.find('.file-collection-delete').text('Remove');
				$file.find('.download-button').show();
				$file.find('.filename .removed-label').remove();
			}
		},
		warnOnNav: function(){
			// Create a pop-up warning if trying to navigate away after adding or removing a file.
			// Event is jQuery namespaced with "fileCollection"
			$(window).on("beforeunload.fileCollection", function(e) {
				var message = "Changes you made may not be saved.", e = e || window.event;
				if (e) {
					e.returnValue = message;
				}
				return "Changes you made may not be saved.";
			});
		}
	};

	$.extend(true, FileCollection.prototype, $.fn.collection.Constructor.prototype, extensionMethods);

	/* COLLECTION PLUGIN DEFINITION
	 * ======================== */

	$.fn.file_collection = function (option) {
		var coll_args = arguments;

		return this.each(function () {
			var $this = $(this),
				collection_id = $this.data('file-collection-input'),
				upload_url = $this.data('file-collection-input-url'),
				data = $this.data('collection'),
				options = typeof option == 'object' ? option : {};

			if (collection_id) {
				options.collection_id = collection_id;
			}
			else if ($this.closest(".collection-items").attr('id')) {
				options.collection_id = '#' + $this.closest(".collection-items").attr('id');
			} else {
				options.collection_id = this.id.length === 0 ? false : '#' + this.id;
				if (!options.collection_id) {
					throw new Error('Could not load collection id');
				}
			}
			if (!data) {
				$this.data('collection', (data = new FileCollection(this, options)));
			}

			if (coll_args.length > 1) {
				var arg1 = coll_args[1];
				var returnval;
			}
			if (option == 'progress') {
				data.progress(arg1);
			}
			if (option == 'fileadd') {
				data.fileAdd(arg1);
			}
			if (option == 'add') {
				data.add();
			}
			if (option == 'error') {
				data.error(arg1);
			}
			if (option == 'wipeError') {
				data.wipeError();
			}
			if (option == 'remove') {
				data.remove(arg1);
			}
			if (option == 'getIndex') {
				returnval = data.getIndex(arg1);
			}
			if (option == 'getItem') {
				returnval = data.getItem(arg1);
			}
			if (option == 'getItems') {
				returnval = data.getItems();
			}
			if (coll_args.length > 1 && typeof coll_args[2] == 'function') {
				coll_args[2].call(this, returnval);
			}
		});
	};

	$.fn.file_collection.defaults = {
		collection_id: null,
		initial_size: 0,
		addcheckfunc: false,
		addfailedfunc: false,
		max: false
	};

	$.fn.file_collection.Constructor = FileCollection;

	/* COLLECTION DATA-API
	 * =============== */
	$(function () {
		$('[data-file-collection-input]').fileupload({
			// url: '', // Derived from data-url attribute on input
			formData: {}, // Must be empty, otherwise sends full form data.
			dataType: 'json',
			mimeType: 'multipart/form-data',
			progressall: function (e, data) {
				var $this = $(e.target);
				$this.file_collection('progress', data);
			},
			done: function (e, data) {
				var $this = $(e.target);

				if(data.result['errors']){
					$this.file_collection('error', data.files[0].name + ': ' +data.result['errors']);
				}else{
					$this.file_collection('fileadd', data.result);
				}
			},
			fail: function (e, data) {
				var $this = $(e.target);

				$this.file_collection('error', 'File Upload failed: ' + data.files[0].name);
			},
			start: function (e) {
				var $this = $(e.target);
				$this.file_collection('wipeError');
			},
			stop: function(e){
			},
		});
		$('body')
		.on('click.file_collection.data-api', '.file-collection-delete', function (e) {
			var $btn = $(e.target);

			$btn.file_collection('remove');
		});
		$("form").on("submit", function(e) {
			// remove all beforeunload events namespaced with "fileCollection" on any form submit
			$(window).off("beforeunload.fileCollection");
			return true;
		});
		$(".download-link").on("click", function(e) {
			// remove all beforeunload events namespaced with "fileCollection" on any file download
			$(window).off("beforeunload.fileCollection");
			return true;
		});
	});

}(window.jQuery);



// WEBPACK FOOTER //
// ./AppBundle/Resources/assets/js/include/jquery.file-collection.js